import type { ClipboardEvent } from 'react'

import isEmpty from 'lodash/fp/isEmpty'
import isFunction from 'lodash/fp/isFunction'

export function handlePaste(onPasteHandler?: (content: string) => void) {
  return (event: ClipboardEvent<HTMLParagraphElement>) => {
    if (!isFunction(onPasteHandler)) {
      return
    }

    const content =
      event.clipboardData.getData('text/html') ||
      event.clipboardData.getData('text')

    if (!isEmpty(content)) {
      event.preventDefault()

      onPasteHandler(content)
    }
  }
}
